import { styled } from '../../Utilities';
import { PivotBase } from './Pivot.base';
import { getStyles } from './Pivot.styles';
/**
 * The Pivot control and related tabs pattern are used for navigating frequently accessed,
 * distinct content categories. Pivots allow for navigation between two or more content
 * views and relies on text headers to articulate the different sections of content.
 */
export var Pivot = styled(PivotBase, getStyles, undefined, {
    scope: 'Pivot'
});
//# sourceMappingURL=Pivot.js.map